module.exports = __webpack_public_path__ + "public/StoreIcon/addDocumentImage.svg?59f32353";